import { useEffect, useState } from 'react';

export type OS = 'mac' | 'windows' | 'linux' | 'ios' | 'android' | 'unknown';

export function useOS(): OS {
  const [os, setOS] = useState<OS>('unknown');

  // eslint-disable-next-line no-restricted-syntax -- reason: Detect OS from navigator API on mount
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const userAgent = navigator.userAgent.toLowerCase();
    const platform = (navigator.platform || '').toLowerCase();

    // Check for Mac/iOS
    if (platform.includes('mac') || /macintosh|mac os x/.test(userAgent)) {
      setOS('mac');
    } else if (/iphone|ipad|ipod/.test(userAgent)) {
      setOS('ios');
    }
    // Check for Windows
    else if (
      platform.includes('win') ||
      /windows|win32|win64/.test(userAgent)
    ) {
      setOS('windows');
    }
    // Check for Linux
    else if (platform.includes('linux') || /linux/.test(userAgent)) {
      setOS('linux');
    }
    // Check for Android
    else if (/android/.test(userAgent)) {
      setOS('android');
    }
    // Default to unknown
    else {
      setOS('unknown');
    }
  }, []);

  return os;
}

export function useKeyboardShortcut(): { key: string; symbol: string } {
  const os = useOS();

  const isMac = os === 'mac' || os === 'ios';

  return {
    key: isMac ? 'Cmd' : 'Ctrl',
    symbol: isMac ? '⌘' : 'Ctrl',
  };
}
